import { render, staticRenderFns } from "./BaseEditPageTextarea.vue?vue&type=template&id=76ab49b1"
import script from "./BaseEditPageTextarea.vue?vue&type=script&lang=js"
export * from "./BaseEditPageTextarea.vue?vue&type=script&lang=js"
import style0 from "./BaseEditPageTextarea.vue?vue&type=style&index=0&id=76ab49b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports